import React, { useState } from 'react';
import { Box, Flex, Text, Grid, Button, Input } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { ArticleCardLarge, ArticleCardMini, TagBadge, SectionHeader } from '../components/ui/Cards';
import { useApp } from '../hooks/useApp';

const CATEGORIES = ['All', 'Smartphones', 'Laptops', 'Audio', 'Smartwatches', 'Cameras', 'AI Tools'];

export default function ArticlesPage() {
  const { articles } = useApp();
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = articles.filter(a => {
    const matchSearch = a.title.toLowerCase().includes(search.toLowerCase()) ||
      a.excerpt?.toLowerCase().includes(search.toLowerCase());
    const matchCat = activeCategory === 'All' || a.category === activeCategory;
    return matchSearch && matchCat;
  });

  const featured = filtered[0];
  const rest = filtered.slice(1);

  return (
    <Box pt="100px" pb="90px" px="5%">
      <Flex align="flex-end" justify="space-between" flexWrap="wrap" gap={4} mb={10}>
        <SectionHeader
          label="Blog & Articles"
          title='All <em style="font-style:normal;color:#00c3ff">Articles</em>'
          desc={`${articles.length} articles covering everything tech for Indian users.`}
        />
      </Flex>

      {/* Filters */}
      <Flex align="center" justify="space-between" flexWrap="wrap" gap={4} mb={8}>
        <Flex gap={2} flexWrap="wrap">
          {CATEGORIES.map(cat => (
            <Button
              key={cat}
              size="sm"
              px={4}
              py={2}
              borderRadius="full"
              fontSize="0.82rem"
              fontWeight={600}
              bg={activeCategory === cat ? '#00c3ff' : 'transparent'}
              color={activeCategory === cat ? '#000' : '#6b7fa0'}
              border={activeCategory === cat ? 'none' : '1px solid rgba(0,195,255,0.15)'}
              _hover={{ bg: activeCategory === cat ? '#00c3ff' : 'rgba(0,195,255,0.1)', color: activeCategory === cat ? '#000' : '#00c3ff' }}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </Button>
          ))}
        </Flex>
        <Flex
          bg="#0f0f14"
          border="1px solid rgba(255,255,255,0.07)"
          borderRadius="8px"
          align="center"
          px={3}
          gap={2}
          w={{ base: '100%', sm: '260px' }}
        >
          <SearchIcon color="#7878a0" w={3.5} h={3.5} />
          <Input
            variant="unstyled"
            placeholder="Search articles..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            color="#f0f0f5"
            _placeholder={{ color: '#7878a0' }}
            fontSize="0.88rem"
            py={2.5}
          />
        </Flex>
      </Flex>

      {/* Featured */}
      {featured && (
        <Box mb={8}>
          <ArticleCardLarge
            article={featured}
            onClick={() => navigate(`/articles/${featured.id}`)}
          />
        </Box>
      )}

      {/* Rest */}
      {rest.length > 0 && (
        <Grid templateColumns={{ base: '1fr', sm: 'repeat(2,1fr)', lg: 'repeat(3,1fr)' }} gap={5.5}>
          {rest.map(article => (
            <ArticleCardLarge
              key={article.id}
              article={article}
              onClick={() => navigate(`/articles/${article.id}`)}
            />
          ))}
        </Grid>
      )}

      {filtered.length === 0 && (
        <Box textAlign="center" py={20} color="#7878a0">
          <Text fontSize="3rem" mb={3}>📝</Text>
          <Text fontSize="1rem">No articles found matching your search.</Text>
        </Box>
      )}
    </Box>
  );
}
